export function initBackToTop() {
    const btn = document.getElementById('backToTop');
    if (!btn) {
        return;
    }
    window.onscroll = function () { scrollFunction(); };
    btn.addEventListener('click', topFunction);
    function scrollFunction() {
        if (!btn) {
            return;
        }
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            btn.classList.add('show');
        }
        else {
            btn.classList.remove('show');
        }
    }
    function topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}
